import React from 'react';
import RestrictionAlert from '@/components/partial/RestrictionAlert/RestrictionAlert';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { cn } from '@gettactic/helpers';

export interface ReserveFormRestrictionAlertsProps {
  className?: string;
}

export const ReserveFormRestrictionAlerts: React.FC<
  ReserveFormRestrictionAlertsProps
> = ({ className }) => {
  const { restrictions } = useReserveForm();

  if (!restrictions.length) return null;

  return (
    <RestrictionAlert
      restrictions={restrictions}
      className={cn('mb-2 max-w-xl', className)}
    />
  );
};
